export default __webpack_public_path__ + "static/media/threeTopRight.982d1982.png";